import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import CityList from '@/views/cities/CityList.vue';
import CityDetail from '@/views/cities/CityDetail.vue';
import EventList from '@/views/events/EventList.vue';
import EventDetail from '@/views/events/EventDetail.vue';
import InsightList from '@/views/insights/InsightList.vue';
import InsightDetail from '@/views/insights/InsightDetail.vue';
import JobList from '@/views/jobs/JobList.vue';
import JobDetail from '@/views/jobs/JobDetail.vue';
import NetworkList from '@/views/networks/NetworkList.vue';
import NetworkDetail from '@/views/networks/NetworkDetail.vue';
import SponsorList from '@/views/sponsors/SponsorList.vue';
import PerkList from '@/views/perks/PerkList.vue';
import PerkDetail from '@/views/perks/PerkDetail.vue';
import PodcastList from '@/views/podcast/PodcastList.vue';
import PodcastDetail from '@/views/podcast/PodcastDetail.vue';
import About from '@/views/about/About.vue';
import Login from '@/views/account/Login.vue';
import Profile from '@/views/account/Profile.vue';
import InitiativeList from '@/views/initiatives/InitiativeList.vue';
import PrivacyPolicy from '@/views/footer/PrivacyPolicy.vue';
import Terms from '@/views/footer/TermsOfUse.vue';
Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/cities', name: 'CityList', component: CityList },
  { path: '/cities/:id', name: 'CityDetail', component: CityDetail },
  { path: '/events', name: 'EventList', component: EventList },
  { path: '/events/:id', name: 'EventDetail', component: EventDetail },
  { path: '/insights', name: 'InsightList', component: InsightList },
  { path: '/insights/:id', name: 'InsightDetail', component: InsightDetail },
  { path: '/jobs', name: 'JobList', component: JobList },
  { path: '/jobs/:id', name: 'JobDetail', component: JobDetail },
  { path: '/networks', name: 'NetworkList', component: NetworkList },
  { path: '/networks/:id', name: 'NetworkDetail', component: NetworkDetail },
  { path: '/sponsors', name: 'SponsorList', component: SponsorList },
  { path: '/perks', name: 'PerkList', component: PerkList },
  { path: '/perks/:id', name: 'PerkDetail', component: PerkDetail },
  { path: '/podcasts', name: 'PodcastList', component: PodcastList },
  { path: '/podcasts/:id', name: 'PodcastDetail', component: PodcastDetail },
  { path: '/about', name: 'About', component: About },
  { path: '/login', name: 'Login', component: Login },
  { path: '/profile', name: 'Profile', component: Profile },
  { path: '/initiatives', name: 'InitiativeList', component: InitiativeList },
  { path: '/privacypolicy', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/termsofuse', name: 'TermsOfUse', component: Terms }
];

const router = new VueRouter({
  // mode:'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
